export const CANONICAL_RECORDING_STATUS_FILTER_OPTIONS: ReadonlyArray<{
  value: string;
  label: string;
}> = [
  { value: "preprocessing", label: "Preprocessing" },
  { value: "processing", label: "Processing" },
  { value: "completed", label: "Completed" },
  { value: "failed", label: "Failed" },
  { value: "stuck", label: "Stuck" },
  { value: "archived", label: "Archived" },
];

export function formatStatusOptionLabel(status: string): string {
  return status
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function buildRecordingStatusFilterOptions(
  availableStatuses: string[],
  canonicalGroups: ReadonlyArray<{ value: string; label: string }> = CANONICAL_RECORDING_STATUS_FILTER_OPTIONS,
): Array<{ value: string; label: string }> {
  const canonicalValues = new Set(canonicalGroups.map((option) => option.value));
  const rawOptions = availableStatuses
    .filter((status) => !canonicalValues.has(status))
    .map((status) => ({
      value: status,
      label: formatStatusOptionLabel(status),
    }))
    .sort((left, right) => left.label.localeCompare(right.label));

  return [
    { value: "all", label: "All statuses" },
    ...canonicalGroups,
    ...rawOptions,
  ];
}
